import type { HTMLAttributes } from 'react';
import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductInformationViewModel } from 'autogen/swagger/all';
import ProductVariantsMapped from './components/ProductVariantsMapped';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing8};
`;

type Variants = Pick<ProductInformationViewModel, 'variants' | 'productId'>;

export default function ChanelVariants({
    variants,
    productId,
    ...restProps
}: Variants & HTMLAttributes<HTMLDivElement>) {
    const hasVariants = !!variants && variants.sections.length > 0;

    if (!hasVariants) return null;

    return <Wrapper {...restProps}>{hasVariants && <ProductVariantsMapped model={variants} />}</Wrapper>;
}
